import React, { useState, useRef, useEffect } from "react";
import {
  FaBell,
  FaEnvelope,
  FaBook,
  FaBars,
  FaArrowRight,
  FaSearch,
  FaCannabis,
} from "react-icons/fa";
import toast from "react-hot-toast";

function Header({ userClaims, handleLogout }) {
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [messagesOpen, setMessagesOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const notificationRef = useRef();
  const messageRef = useRef();
  const dropdownRef = useRef();

  // Dışarı tıklamaları algılamak için
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setNotificationsOpen(false);
      }
      if (messageRef.current && !messageRef.current.contains(event.target)) {
        setMessagesOpen(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const confirmLogout = () => {
    toast((t) => (
      <div>
        <p>Çıkış yapmak istediğinizden emin misiniz?</p>
        <div className="mt-2 flex space-x-2">
          <button
            onClick={() => {
              toast.dismiss(t.id);
              handleLogout();
            }}
            className="px-3 py-1 text-white bg-red-600 rounded"
          >
            Evet
          </button>
          <button
            onClick={() => toast.dismiss(t.id)}
            className="px-3 py-1 text-gray-600 bg-gray-200 rounded"
          >
            Hayır
          </button>
        </div>
      </div>
    ));
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-white border-b shadow-lg">
      <div className="mx-auto flex items-center justify-between p-3">
        {/* Logo */}
        <img
          src="https://aydin.bel.tr/Content/images/kurumsal/logo/2022/Yatay_kullanim.png"
          alt="Logo"
          className="h-10"
        />

        {/* Sağ Menü */}
        <div className="hidden md:flex items-center space-x-4">
          {/* Arama */}
          <div className="relative search-container flex items-center">
            <div
              className={`flex items-center border rounded-full overflow-hidden transition-all duration-300 ${
                searchOpen ? "w-64" : "w-10"
              }`}
            >
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Ara..."
                className={`transition-all duration-300 ease-in-out ${
                  searchOpen ? "w-full px-4" : "w-0"
                } text-sm h-10 border-none focus:outline-none`}
                style={{ visibility: searchOpen ? "visible" : "hidden" }}
              />
              <button
                className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-600 hover:text-gray-800"
                onClick={() => setSearchOpen((prev) => !prev)}
              >
                <FaSearch />
              </button>
            </div>
          </div>

          {/* Bildirim Zili */}
          <div className="relative" ref={notificationRef}>
            <button
              className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-600 hover:text-gray-800"style={{
                borderRadius:25 }}
              onClick={() => setNotificationsOpen((prev) => !prev)}
            >
              <FaBell className="w-6 h-6" />
            </button>
            {notificationsOpen && (
              <div className="absolute right-0 mt-2 w-64 bg-white border rounded shadow-lg p-4">
                <p className="text-sm text-gray-600">Hiç bildiriminiz yok.</p>
              </div>
            )}
          </div>

          {/* Mesajlar */}
          <div className="relative" ref={messageRef}>
            <button
              className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-600 hover:text-gray-800" style={{
                borderRadius:25 }}
              onClick={() => setMessagesOpen((prev) => !prev)}
            >
              <FaEnvelope className="w-6 h-6" />
            </button>
            {messagesOpen && (
              <div className="absolute right-0 mt-2 w-64 bg-white border rounded shadow-lg p-4">
                <p className="text-sm text-gray-600">Hiç mesajınız yok.</p>
              </div>
            )}
          </div>

          {/* Kullanım Kılavuzu */}
          <button
            onClick={() => (window.location.href = "/kullanim-kilavuzu")}
            className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-600 hover:text-gray-800" style={{
              borderRadius:25
            }}
          >
            <FaBook className="w-6 h-6" />
          </button>

          <button
            onClick={() => (window.location.href = "/settings")}
            className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-600 hover:text-gray-800" style={{
              borderRadius:25
            }}
          >
            <FaCannabis className="w-6 h-6" />
          </button>
          {/* Türk Bayrağı */}
          <div className="w-9 h-9 rounded-full overflow-hidden border">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Flag_of_Turkey.svg/2560px-Flag_of_Turkey.svg.png"
              alt="Türk Bayrağı"
              className="object-cover w-full h-full"
            />
          </div>

          {/* Çıkış Yap */}
          <button
            onClick={confirmLogout}
            className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-600 hover:text-gray-800" style={{
              borderRadius:25
            }}
          >
            <FaArrowRight className="w-6 h-6" />
          </button>
        </div>

        {/* Mobil Menü */}
        <div className="md:hidden relative" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen((prev) => !prev)}
            className="text-gray-600 hover:text-gray-800"
          >
            <FaBars className="w-6 h-6" />
          </button>
          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg">
              <button
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => setNotificationsOpen(true)}
              >
                <FaBell className="w-5 h-5 mr-2" />
                Bildirimler
              </button>
              <button
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => setMessagesOpen(true)}
              >
                <FaEnvelope className="w-5 h-5 mr-2" />
                Mesajlar
              </button>
              <button
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => (window.location.href = "/kullanim-kilavuzu")}
              >
                <FaBook className="w-5 h-5 mr-2" />
                Kullanım Kılavuzu
              </button>

              <button
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => (window.location.href = "/kullanim-kilavuzu")}
              >
                <FaCannabis className="w-5 h-5 mr-2" />
                Farklı Bir şey
              </button>
              
              <button
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={confirmLogout}
              >
                Çıkış Yap
              </button>
              
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
